import axios from 'axios'
import Service, { prepareURL } from '@/api/service'
import getFormDataFromJSON from '@/common/js/formdata'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

/*
    using '...Service('/url/:id/')' in object provides methods:
        fetch
        get
        delete
        put
        save
 */

export const SiteSettings = {
  update: payload => {
    return axios.put('/admin/core/settings/', payload)
  },
  get: payload => {
    return axios.get('/admin/core/settings/', payload)
  }
}

export const PageSettings = {
  update: payload => {
    return axios.put('/admin/core/page-settings/', payload)
  },
  get: payload => {
    return axios.get('/admin/core/page-settings/', payload)
  }
}

export const Attachment = {
  ...Service('/admin/attachments/:id/'),
  upload: payload => {
    return axios.post('/admin/attachments/', payload, {
      headers: { 'content-type': 'multipart/form-data' }
    })
  }
}

export const Page = {
  ...Service('/admin/pages/:id/'),
  revision(params, payload) {
    const url = prepareURL(`/admin/pages/:id/revision/`, params)
    return axios.post(url, payload)
  },
  preview(urlParams, payload) {
    const url = '/admin/pages/:id/preview/'
    return axios.post(prepareURL(url, urlParams), payload)
  }
}

export const CampPage = {
  ...Service('/admin/pages/camps/:id/'),
  revision(params, payload) {
    const url = prepareURL(`/admin/pages/camps/:id/revision/`, params)
    return axios.post(url, payload)
  },
  preview(urlParams, payload) {
    const url = '/admin/pages/camps/:id/preview/'
    return axios.post(prepareURL(url, urlParams), payload)
  }
}

export const PageTree = {
  fetch() {
    return axios.get('/admin/pages/tree/')
  },
  delete(urlParams) {
    const url = '/admin/pages/:id/'
    return axios.delete(prepareURL(url, urlParams))
  }
}

export const CampPageTree = {
  fetch() {
    return axios.get('/admin/pages/camps/tree/')
  },
  delete(urlParams) {
    const url = '/admin/pages/camps/:id/'
    return axios.delete(prepareURL(url, urlParams))
  }
}

export const Revision = Service('/admin/revisions/:id/')

export const Article = {
  ...Service('/admin/articles/:id/'),
  preview(payload) {
    return axios.post('/admin/articles/preview/', payload)
  }
}

export const Widget = {
  ...Service('/admin/widgets/:id/'),
  types(params) {
    return axios.get('/widgets/admin/types/', { params })
  },
  validate(payload) {
    return axios.post('/widgets/admin/validate/', payload)
  },
  available(params) {
    return axios.get('/widgets/admin/available/', { params })
  },
  preview(payload) {
    return axios.post('/widgets/admin/preview/', payload)
  }
}

export const Menu = {
  ...Service('/admin/menu/:id/')
}

export const Link = {
  availableLinkOptions() {
    return axios.get('/admin/links/available-options/')
  },
  availableWidgets(params) {
    return axios.get('/admin/links/available-widgets/', { params })
  }
}

export const Auth = {
  login(payload) {
    return axios.post('/public/users/auth/login/', payload)
  },
  codeVerification(payload) {
    return axios.post('/public/users/auth/login/code/verification/', payload)
  }
}

export const Image = {
  ...Service('/images/admin/:id/'),
  save: (payload, onUploadProgress) => {
    const formData = getFormDataFromJSON(payload)
    return axios.post('/images/admin/', formData, {
      headers: {
        'content-type': 'multipart/form-data'
      },
      onUploadProgress
    })
  },
  update: (urlParams, payload) => {
    const formData = getFormDataFromJSON(payload)
    const defaultUpdate = Service('/images/admin/:id/')['update']
    return defaultUpdate(urlParams, formData, {
      'content-type': 'multipart/form-data'
    })
  }
}

export const User = {
  ...Service('/admin/users/:id/'),
  createOTPCode(params) {
    const url = prepareURL(`/admin/users/:id/create-otp-code/`, params)
    return axios.post(url)
  }
}

export const Dashboard = {
  getContentCounters() {
    return axios.get('/admin/dashboard/content-counters/')
  },
  getRecentPages() {
    return axios.get('/admin/dashboard/recent-pages/')
  },
  getUser() {
    return axios.get('/admin/dashboard/user/')
  }
}

export const CampApplication = {
  ...Service('/admin/camps/applications/:id/'),
  markAsPaid(params) {
    const url = prepareURL(
      `/admin/camps/applications/:id/mark-as-paid/`,
      params
    )
    return axios.post(url)
  },
  markProcessing(params) {
    const url = prepareURL(
      `/admin/camps/applications/:id/mark-as-processing/`,
      params
    )
    return axios.post(url)
  },
  markApproved(params, payload) {
    const url = prepareURL(`/admin/camps/applications/:id/approved/`, params)
    return axios.patch(url, payload)
  },
  markUnsuccessful(params, payload) {
    const url = prepareURL(
      `/admin/camps/applications/:id/unsuccessful/`,
      params
    )
    return axios.patch(url, payload)
  },
  refund(params, payload) {
    const url = prepareURL(`/admin/camps/applications/:id/refund/`, params)
    return axios.post(url, payload)
  },
  choices() {
    return axios.get('/public/camps/applications/choices/')
  }
}

export const CampCourse = {
  ...Service('/admin/camps/courses/:id/')
}

export const CampLesson = {
  ...Service('/admin/camps/lessons/:id/')
}
